import styles from '../../css/MainSearch.module.css';
import { useState } from 'react';
import { BsQuestionCircleFill, BsExclamation } from 'react-icons/bs';
import { useTranslation } from "react-i18next";
import MultiRangeSlider from '../../component/MultiRangeSlider2';

export default function MainSearchArea({
  searchClusterByText,
  sectorData,
  analysisData
}) {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const [example, setSample] = useState(false);

  const handleChange = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  }

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      // Enter 키가 눌렸을 때 실행할 동작
      onSubmit(e);
    }
  }

  const onSubmit = (e) => {
    e.preventDefault();
    // api 호출 이벤트 처리 
    searchClusterByText(search);
  }

  return (
    <div className={styles.mainForm}>
      <div className={styles.inputWrap}>
        <input type='text'
          className={styles.search}
          placeholder={t("input_text")}
          value={search}
          onChange={handleChange}
          onKeyDown={handleEnter}
        />
        <BsQuestionCircleFill className={styles.icon} onMouseEnter={()=>setSample(true)} onMouseLeave={()=>setSample(false)} />
        <input type='button' className={styles.submit} onClick={onSubmit}/>
      </div>
      {
        example && 
        <div className={styles.ex} style={{zIndex: '500'}}>
          <h1>{t("sample")}</h1>
          <p><BsExclamation className={styles.exIcon}/>{t("sample_text1")}</p>
          <p><BsExclamation className={styles.exIcon}/>{t("sample_text2")}</p>
          <p><BsExclamation className={styles.exIcon}/>{t("sample_text3")}</p>
          <h1 style={{marginTop: '10px'}}>기준</h1>
          <p style={{paddingLeft: '20px'}}>
            상점수, 회복탄력성, 매출
          </p>
          <h1 style={{marginTop: '10px'}}>범위</h1>
          <p style={{paddingLeft: '20px'}}>
            상위 10 곳, 하위 20 곳 등
          </p>
          <h1 style={{marginTop: '10px'}}>범위</h1>
          <p style={{paddingLeft: '20px'}}>
            강남구, 강서구, 동작구 등
          </p>
          <h1 style={{marginTop: '10px'}}>상권분석</h1>
          <p style={{paddingLeft: '20px', paddingRight: '20px', wordBreak: 'keep-all'}}>
            소매, 생활서비스, 부동산, 관광여가오락, 숙박, 스포츠, 음식, 학문교육, 의료
          </p>
        </div>
      }
    </div>
  )
}